// src/components/Billing/Styles/CheckoutHome.Style.js
// @flow

import { CHECKOUT_PAPER } from './PlansHome.Style';

// If you had references to STRIPE_FORM_WIDTH or anything else, keep them:
const STRIPE_FORM_WIDTH = 450;

const checkoutHomeStyles = {
  contentCtr: (theme) => ({
    flexGrow: 1,
    marginTop: theme.spacing(2),
    textAlign: 'center',
    maxWidth: 700,
    width: '100%',
    margin: '0 auto',
    padding: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: '95vw',
      marginTop: theme.spacing(2),
      padding: `${theme.spacing(2)}px 0px`
    }
  }),

  stripeCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    '& iframe.ElementsApp': {
      background: 'green'
    },
    '& .ElementsApp .InputElement': {
      backgroundColor: 'white',
      borderRadius: 0,
      padding: `${theme.spacing(2)} 30px`,
      minWidth: '100%',
      textAlign: 'left',
      margin: 0,
      fontSize: '1rem',
      '&::placeholder': {
        color: '#a3c2d9'
      }
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '84vw'
    }
  }),

  formPaper: (theme) => ({
    ...CHECKOUT_PAPER,
    width: `calc(${STRIPE_FORM_WIDTH}px + ${theme.spacing(6)})`,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    '& p, & h2, & h3': {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5)
    },
    '& h2': {
      color: theme.palette.primary.main,
      fontSize: '2rem',
      paddingBottom: 0
    },
    '& h3': {
      fontWeight: 600
    },
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '90vw',
      minWidth: 0,
      paddingLeft: theme.spacing(1),
      paddingRight: theme.spacing(1)
    }
  }),

  totalCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1)
  }),

  totalLabel: (theme) => ({
    fontSize: '1.3rem',
    fontWeight: 600
  }),
  totalCost: (theme) => ({
    fontSize: '1.3rem',
    color: theme.palette.primary.main,
    fontWeight: 600
  }),
  totalCaption: (theme) => ({
    fontWeight: 500
  }),
  formTitle: (theme) => ({
    color: theme.layout?.customProps?.gray
  }),
  formLabel: (theme) => ({
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    marginTop: theme.spacing(1.5),
    marginBottom: -theme.spacing(0.5)
  }),
  errorLabel: (theme) => ({
    marginLeft: theme.spacing(1),
    color: '#f44336 !important'
  }),
  checkoutInputForm: (theme) => ({
    '& input': {
      padding: '18.5px 14px',
      fontSize: '1em'
    },
    '& .MuiOutlinedInput-input::placeholder': {
      color: 'black'
    },
    '& .MuiInputBase-input::-webkit-input-placeholder': {
      opacity: 0.75
    }
  }),
  striked: (theme) => ({
    textDecoration: 'line-through',
    fontWeight: 600,
    fontSize: '0.9rem',
    paddingRight: 8,
    color: theme.layout?.customProps?.gray
  }),
  expandableLabel: (theme) => ({
    cursor: 'pointer',
    fontWeight: 'bold',
    color: theme.palette.primary.main,
    marginTop: theme.spacing(2)
  }),
  inlineIcon: (theme) => ({
    position: 'relative',
    top: 8
  }),
  newInputForm: (theme) => ({
    // for older references to classes.newInputForm
  }),
  newFormElt: (theme) => ({
    // for older references to classes.newFormElt
  }),

  // Two-step checkout flow styles
  orderSummaryBox: (theme) => ({
    padding: theme.spacing(2.5),
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[200]}`,
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2)
    }
  }),

  summaryRow: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(0.75),
    '&:last-child': {
      marginBottom: 0
    }
  }),

  // Enhanced title for Order Summary (primary visual element in Step 2)
  orderSummaryTitle: (theme) => ({
    fontSize: '1.25rem',
    fontWeight: 600,
    color: theme.palette.text.primary
  }),

  // Enhanced price display for Order Summary
  orderSummaryPrice: (theme) => ({
    fontSize: '1.25rem',
    fontWeight: 600,
    color: theme.palette.primary.main
  }),

  editLink: (theme) => ({
    color: theme.palette.primary.main,
    cursor: 'pointer',
    textDecoration: 'underline',
    fontSize: '0.875rem',
    fontWeight: 500,
    '&:hover': {
      textDecoration: 'none'
    }
  }),

  primaryCta: (theme) => ({
    marginTop: theme.spacing(2),
    padding: `${theme.spacing(1.5)} ${theme.spacing(4)}`,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: theme.spacing(2)
    }
  }),

  checkoutStepper: (theme) => ({
    maxWidth: 500,
    margin: '0 auto',
    marginBottom: theme.spacing(1),
    '& .MuiStepLabel-label': {
      fontSize: '0.8125rem',
      fontWeight: 500,
    },
    '& .MuiStepLabel-label.Mui-active': {
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
    '& .MuiStepLabel-label.Mui-completed': {
      fontWeight: 500,
    },
    '& .MuiStepButton-root:not(.Mui-disabled)': {
      cursor: 'pointer',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    }
  }),

  infoLabel: (theme) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    fontSize: '0.875rem',
    color: theme.palette.text.secondary
  })
};

export default checkoutHomeStyles;